module.exports = __webpack_public_path__ + "media/images/sale_crm/projects-d40d7b5896ba1a47f7a01a17286763e1.svg";